import { OFFER_CARGO_VEHICLE_SHAPES_LIST } from "@/shared/constants/offer-cargo";
import { MobileDeliveryProposalFormTable } from "@/widgets/delivery-proposal-form-table/mobile-delivery-proposal-form-table";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DeliveryProposalFormLayout } from "../../../../../widgets/delivery-proposal-form-layout";
import { DeliveryProposalFormTable } from "../../../../../widgets/delivery-proposal-form-table";
import type { CarrierDeliveryProposalCreatePageProps } from "../../../model";

export const VehicleForm = (props: {
  draftOfferCargo: CarrierDeliveryProposalCreatePageProps["draftOfferCargo"];
  previewValues: NonNullable<
    CarrierDeliveryProposalCreatePageProps["previewValues"]
  >;
}) => {
  const { t } = useTranslation();
  const { draftOfferCargo, previewValues } = props;
  const vehicleData = previewValues.vehicle?.data;

  const vehicleCells = [
    null,
    previewValues.vehicle?.status === "success" ? (
      vehicleData?.name && vehicleData?.number ? (
        `${vehicleData.name} ${vehicleData.number}`
      ) : null
    ) : (
      <CircularProgress key="proposal" size={16} />
    ),
  ];

  const vehicleWeightCells = [
    draftOfferCargo.data?.vehicleWeight
      ? `${draftOfferCargo.data?.vehicleWeight}t`
      : null,
    vehicleData?.weight ? `${vehicleData.weight}t` : null,
  ];

  const vehicleShapeCells = [
    OFFER_CARGO_VEHICLE_SHAPES_LIST.find(
      (shape) => shape.value === draftOfferCargo.data?.vehicleShape,
    )?.label,
    (() => {
      const shapeText: string[] = [];
      if (vehicleData?.shapeText) {
        shapeText.push(vehicleData?.shapeText);
      }
      if (vehicleData?.equipmentsText) {
        shapeText.push(`装備品 : ${vehicleData?.equipmentsText.join(", ")}`);
      }
      return shapeText.join("\n");
    })(),
  ];

  const vehicleEquipmentMemoCells = [
    draftOfferCargo.data?.vehicleEquipmentMemo,
    null,
  ];

  return (
    <DeliveryProposalFormLayout title="車両" isLoading={false}>
      <div>
        {/* PC用のフォーム */}
        <Box display={{ xs: "none", sm: "block" }}>
          <DeliveryProposalFormTable
            headers={["荷物", "提案"]}
            rows={[
              {
                title: "車両",
                cells: vehicleCells,
              },
              {
                title: t("offerCargo.vehicleWeight"),
                cells: vehicleWeightCells,
              },
              {
                title: t("offerCargo.vehicleShape"),
                cells: vehicleShapeCells,
              },
              {
                title: t("offerCargo.vehicleEquipmentMemo"),
                cells: vehicleEquipmentMemoCells,
              },
            ]}
          />
        </Box>

        {/* モバイル用のフォーム */}
        <Box display={{ xs: "block", sm: "none" }}>
          <MobileDeliveryProposalFormTable
            items={[
              {
                label: "車両",
                cargo: vehicleCells[0],
                proposal: vehicleCells[1],
              },
              {
                label: t("offerCargo.vehicleWeight"),
                cargo: vehicleWeightCells[0],
                proposal: vehicleWeightCells[1],
              },
              {
                label: t("offerCargo.vehicleShape"),
                cargo: vehicleShapeCells[0],
                proposal: vehicleShapeCells[1],
              },
              {
                label: t("offerCargo.vehicleEquipmentMemo"),
                cargo: vehicleEquipmentMemoCells[0],
                proposal: vehicleEquipmentMemoCells[1],
              },
            ]}
          />
        </Box>
      </div>
    </DeliveryProposalFormLayout>
  );
};
